import * as React from 'react';
import * as classNames from 'classnames/bind';

import styles from './Button.scss';
import { LinkComponentProps } from './LinkButton';

export interface Props {
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: (event: {}) => void;
  icon?: string;
  secondary?: boolean;
  disabled?: boolean;
  Link?: React.ComponentType<LinkComponentProps>;
  large?: boolean;
}

const cx = classNames.bind(styles);

const Button: React.SFC<Props> = props => {
  const { type, children, onClick, icon, disabled, secondary, large, Link } = props;
  const className = cx('button', {
    secondary,
    large,
    withIcon: icon ? true : false,
    primary: !secondary,
  });

  if (Link) {
    return <Link className={className}>{children}</Link>;
  }

  return (
    <button type={type} className={className} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// /www/client/src/components/Button/Button.tsx